<template>
  <div class="outDiv">
    <div class="gather animated fadeInUp">
      <page-left :config="pageLeftConfig" :lists="lists" @changeItems="changeItems" @changeAll="changeAll" @loadMoreVideoData="loadMoreVideoData" />
      <div class="right-video" v-show="!type">
        <Player width="100%" height="70vh" :videoUrl="videoUrl" />
      </div>
      <div class="videoList" v-if="type">
        <div class="videoItems" v-for="item in videoUrlList" :key="item.id">
          <Player width="410" height="300" :videoUrl="item.videoUrl" />
          <p class="videoTit">{{ item.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import { mapState, mapMutations } from 'vuex'
import { getEquipmentListApi, getEquipmentInfoApi, getVideoUrlApi } from '@/request/api'
export default {
  components: {
    pageLeft: () => import('@/views/equipment/component/pageLeft.vue'),
    Player: () => import('@/components/Player.vue')
  },
  data() {
    return {
      type: 0,
      sizeType: false,
      videoId: '',
      videoUrl: '',
      videoUrlList: [],
      pageLeftConfig: {
        placeholder: '搜索视频设备名称（编号）',
        img: this.$imgOnlineUrl + '/equipment/icon1.png'
      },
      lists: [],
      videoPageNum: 1,
      videoPageSize: 10,
      videoCount: 0
    }
  },
  watch: {
    '$route.query': {
      handler(newVal) {
        this.channel_id = newVal.id

        this.getEquipmentList()
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      farmID: (state) => state.user.farmID
    })
  },
  methods: {
    ...mapMutations('user', ['SET_EQUIPMENT_Name']),
    loadMoreVideoData() {
      if (this.lists.length && this.lists.length == this.videoCount) return
      this.videoPageNum++
      this.getEquipmentList(this.videoPageNum)
    },
    changeAll(type) {
      this.type = type
      if (type) {
        this.buildVideoUrlList()
      } else if (this.lists.length) {
        const item = this.lists.find((t) => t.id === this.videoId) || this.lists[0]

        this.videoId = item.id

        this.getVideoUrlAddress(item.number)
      }
    },

    changeItems({ id, type, sizeType }) {
      this.sizeType = sizeType
      this.type = type
      this.videoId = id
      const item = this.lists.find((t) => t.id === id)
      if (item) {
        this.getVideoUrlAddress(item.number)
      }
    },
    async getEquipmentInfoApi_status() {
      const { code, results } = await getEquipmentInfoApi({
        manor_id: +this.farmID,
        table_id: this.lists[0].id,
        act: 'status'
      })
      if (code === 0) {
        this.online = results.online
      }
    },
    async getEquipmentList(pageNum = 1) {
      if (!this.channel_id) return
      const { code, count, page_num, page_size, results } = await getEquipmentListApi({
        manor_id: +this.farmID,
        channel_id: this.channel_id,
        page_num: pageNum,
        page_size: 20
      })
      if (code === 0) {
        const filtered = results.filter((item) => {
          return item.title.indexOf('大') == -1
        })
        if (pageNum > 1) {
          this.lists = [...this.lists, ...filtered]
        } else {
          this.lists = filtered
        }
        this.videoCount = count
        this.videoPageNum = page_num
        this.videoPageSize = page_size
        if (this.type) {
          this.buildVideoUrlList()
        } else if (this.lists.length) {
          this.videoId = this.lists[0].id

          this.getVideoUrlAddress(this.lists[0].number)
        }
      }
    },

    async fetchVideoUrl(deviceSerial) {
      const accessToken = localStorage.getItem('hsAccessToken') || ''
      const params = qs.stringify({
        accessToken,
        deviceSerial
      })
      const res = await getVideoUrlApi(params)
      if (res.code != 200) return ''
      return res.data.url
    },

    async getVideoUrlAddress(deviceSerial) {
      const url = await this.fetchVideoUrl(deviceSerial)
      if (url) {
        this.videoUrl = url
      }
    },
    async buildVideoUrlList() {
      if (!this.lists.length) {
        this.videoUrlList = []
        return
      }
      const videoUrlList = await Promise.all(
        this.lists.map(async (item) => {
          const videoUrl = await this.fetchVideoUrl(item.number)

          return {
            ...item,

            videoUrl
          }
        })
      )
      this.videoUrlList = videoUrlList
    },
    changeTab3({ id, icon }) {
      if (id) {
        this.changeIndex3 = id
      }
      sessionStorage.setItem('childTitle3', this.changeIndex3)
      sessionStorage.setItem('equipmentId', id)
      sessionStorage.setItem('equipmentName', icon)
      this.SET_EQUIPMENT_Name({ icon })
      switch (icon) {
        case 'records':
          this.$router.push({
            name: 'records'
          })
          break
        case 'video':
          this.$router.push({
            name: 'grow',
            query: { id }
          })
          break
        case '':
          this.$router.push({
            name: 'grow',
            query: { id: this.changeIndex3 }
          })
          break
      }
    }
  }
}
</script>

<style lang="less" scoped>
.outDiv {
  padding: 0 48px;
  .gather {
    width: 100%;
    display: flex;
    align-items: center;
    background-color: #071a2c;
    padding: 0 0 24px;
    justify-content: space-between;
    position: relative;
    .videoList {
      width: 1300px;

      height: 800px;

      display: flex;

      flex-wrap: wrap;

      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 7px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;

        background-color: #3e90e5;
      }

      .videoItems {
        width: 410px;

        margin: 0 10px 10px 0;

        .videoTit {
          width: 100%;

          font-size: 14px;

          padding: 0 10px;

          position: relative;

          &::before {
            content: '';

            width: 4px;

            height: 100%;

            border-radius: 2px;

            background-color: #3e90e5;

            position: absolute;

            top: 0;

            left: 0;
          }
        }
      }
    }

    .right-video {
      width: 1300px;

      height: 800px;

      background: #0e2138;

      display: flex;

      padding: 20px 53px 0;

      flex-direction: column;

      .video-box {
        width: 100%;

        height: 585px;

        border: 1px solid #000;
      }

      .control {
        width: 100%;

        display: flex;

        align-items: center;

        justify-content: center;

        margin-top: 53px;

        img {
          width: 22px;
          height: 22px;
          cursor: pointer;
        }

        span {
          font-size: 22px;
          margin: 0 25px;
        }
      }

    }
  }
}
</style>
